import { useMutation } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export const useAttachmentDelete = () => {
  return useMutation({
    mutationFn: async (filePath: string) => {
      const { error } = await supabase.storage
        .from('support-attachments')
        .remove([filePath]);

      if (error) throw error;
    },
    onError: (error) => {
      console.error('Erro ao deletar arquivo:', error);
      toast.error('Erro ao deletar arquivo');
    },
  });
};
